import { render, staticRenderFns } from "./itemWrapper.vue?vue&type=template&id=d135a67e&scoped=true"
import script from "./itemWrapper.vue?vue&type=script&lang=js"
export * from "./itemWrapper.vue?vue&type=script&lang=js"
import style0 from "./itemWrapper.vue?vue&type=style&index=0&id=d135a67e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135a67e",
  null
  
)

export default component.exports